export default __webpack_public_path__ + "images/DEEPECHO_logo_small.64813dd98d9af8ea4eb229d9938c9054.png";